export default __webpack_public_path__ + "static/char-s-61-kr-9ad83debfabd53fdd70413f810fd03d8.png";